<template>
  <div>
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Add Query</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="6" md="6">
            <p><b>Title*</b></p>
            <v-text-field
              outlined
              dense
              type="text"
              v-model="title"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col cols="12" sm="12" md="6">
            <p><b>Description</b></p>
            <v-textarea
              outlined
              name="input-7-4"
              v-model="description"
              label="Enter Description"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col cols="12" sm="6" md="6">
            <p><b>URL</b>&nbsp;<i>(path link)</i></p>
            <v-text-field
              outlined
              dense
              type="text"
              v-model="url"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col cols="12" sm="6" md="3">
            <p><b>Query Type*</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="query_type"
              :items="query_type_list"
              item-text="name"
              item-value="id"
              label="Query Type"
              outlined
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <p><b>Module*</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="role_type"
              :items="role_type_list"
              item-text="type"
              item-value="id"
              label="Module"
              outlined
            />
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col cols="12" sm="6" md="3">
            <p><b>Email*</b></p>
            <v-text-field
              outlined
              dense
              type="text"
              v-model="email"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <p><b>Evidance(if Any)</b></p>
            <v-file-input
              placeholder="Pick File If Any"
              prepend-icon="mdi-camera"
              show-size
              v-model="evidance"
            ></v-file-input>
            <!-- <v-file-input label="Attachment" v-model="evidance"></v-file-input> -->
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-btn
            color="primary"
            dark
            class="mb-2"
            :loading="loader"
            @click="save()"
            >Save</v-btn
          >
        </v-row>
      </v-card>
      <hr />
      <v-card class="box" v-if="query_list.length > 0">
        <v-data-table :headers="headers" :items="query_list">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Queries</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    title: "",
    url: "",
    description: "",
    query_type_list: [],
    role_type_list: [],
    query_type: "",
    role_type: "",
    email: "",
    evidance: null,
    query_list: [],
    headers: [
      { text: "Title", value: "title" },
      { text: "Description", value: "description" },
      { text: "Ticketid", value: "ticketid" },
      { text: "Post Date", value: "post_date" },
      { text: "Email", value: "email" },
      { text: "Type", value: "querytype" },
      { text: "Module", value: "module" },
      { text: "Status", value: "currentquerystatus" },
    ],
  }),
  methods: {
    clearData() {
      (this.title = ""),
        (this.query_type = ""),
        (this.role_type = ""),
        (this.evidance = null),
        (this.description = ""),
        (this.url = "");
    },
    save() {
      if (this.title == "" || this.title == null) {
        this.showSnackbar("red", "Enter Title");
        return;
      }
      if (this.query_type == "" || this.query_type == null) {
        this.showSnackbar("red", "Please Select Query Type");
        return;
      }
      if (this.role_type == "" || this.role_type == null) {
        this.showSnackbar("red", "Please Select Module");
        return;
      }
      if (this.email == "" || this.email == null) {
        this.showSnackbar("red", "Please Enter Email");
        return;
      }
      if (this.url.length != 0) {
        let regexp =
          /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
        if (!regexp.test(this.url)) {
          this.showSnackbar("#b71c1c", "Please enter valid URL!");
          return;
        }
      }
      this.loader = true;
      let formData = new FormData();
      formData.append("file", this.evidance);
      formData.append("title", this.title);
      formData.append("description", this.description);
      formData.append("email", this.email);
      formData.append("query_type", this.query_type);
      formData.append("role_type", this.role_type);
      formData.append("url", this.url);
      axios
        .post("/Query/saveQuery", formData)
        .then((res) => {
          if (res.data.flag == "Yes") {
            this.showSnackbar("green", "Query Posted Successfully...");
            this.query_list = res.data.query_list;
            this.clearData();
            this.loader = false;
          } else {
            this.showSnackbar("red", "Something Went Wrong...");
            this.loader = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
        })
        .finally(() => {
          this.loader = false;
        });
    },
    onLoad() {
      axios
        .get("/Query/getInitialQueryData")
        .then((res) => {
          if (res.data.flag == "Yes") {
            this.email = res.data.email;
            this.query_type_list = res.data.querytype_list;
            this.role_type_list = res.data.roletype_list;
            this.query_list = res.data.query_list;
          } else {
            this.showSnackbar("#b71c1c", "Wrong information");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
        })
        .finally(() => {
          // 'use strict';
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
.table-head-background {
  background-color: #fcc96f;
  color: #fff;
  font-weight: 700;
}
.tc-title {
  background-image: linear-gradient(-90deg, #fcc96f, #fcb63c);
  color: #fff;
  font-weight: 700;
  margin: 0px !important;
  padding: 0px !important;
}
.text-left {
  font-size: 14px;
  font-weight: bold;
}
.text {
  color: blue;
  font-weight: 600;
  font-size: 14px;
}
</style>
